import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";
function ProjectBody (props){
    const sections = props.sections;
    const projectPoints = ["Line1", "Line2", "Line3", "Line4"];
  return (
    <div className={styles.detail}>
      <div className={styles.row}>
        <InputControl
          label="Title"
          value={props.information[sections.project].details[props.activeDetailIndex]?.title}
          placeholder="Enter title eg. Chat app"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.project]: {...prev[sections.project],
                details: prev[sections.project].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, title: event.target.value } : detail
                ),
                }
            }))
          }
        />

        {/* <InputControl
          label="Project Type"
          value={values.type}
          placeholder="| Course/Self Learning Proejct"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, type: event.target.value }))
          }
        /> */}
      </div>
      <div className={styles.row}>
        <InputControl
          label="Start Date"
          type="date"
          placeholder="start date of work"
          value={props.information[sections.project].details[props.activeDetailIndex]?.startDate}
          // value={values.startDate}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.project]: {...prev[sections.project],
                  details: prev[sections.project].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, startDate: event.target.value } : detail
                ),
                }
            }))
          }
        />
        <InputControl
          label="End Date"
          type="date"
          placeholder="end date of work"
          value={props.information[sections.project].details[props.activeDetailIndex]?.endDate}
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.project]: {...prev[sections.project],
                  details: prev[sections.project].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, endDate: event.target.value } : detail
                ),
                }
            }))
          }
        />
      </div>
      <div className={styles.row}>
        <InputControl
          label="Deployed Link"
          value={props.information[sections.project].details[props.activeDetailIndex]?.link}
          placeholder="deployed link"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.project]: {...prev[sections.project],
                  details: prev[sections.project].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, link: event.target.value } : detail
                ),
                }
            }))
          }
        />
        <InputControl
          label="Github Link"
          value={props.information[sections.project].details[props.activeDetailIndex]?.github}
          placeholder="github link"
          onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.project]: {...prev[sections.project],
                  details: prev[sections.project].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, github: event.target.value } : detail
                ),
                }
            }))
          }
        />
      </div>
      <InputControl
        label="Overview"
        value={props.information[sections.project].details[props.activeDetailIndex]?.overview}
        placeholder="Enter basic overview of project"
        onChange={(event) =>
            props.setInformation((prev) => ({ ...prev, 
                [sections.project]: {...prev[sections.project],
                  details: prev[sections.project].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, overview: event.target.value } : detail
                ),
                }
            }))
        }
      />

      <div className={styles.column}>
        <label>Enter project description</label>
        {projectPoints.map((line, index) => (
          <InputControl
            placeholder={line}
            value={props.information[sections.project].details[props.activeDetailIndex]?.points ? props.information[sections.project].details[props.activeDetailIndex].points[index] : ""}
            onChange={(event) => 
              props.setInformation((prev) => ({ ...prev, 
                [sections.project]: {...prev[sections.project],
                details: prev[sections.project].details.map((detail, detailIndex) => 
                  detailIndex === props.activeDetailIndex? {
                      ...detail,
                      points: detail.points.map((point, pointIndex) => 
                        pointIndex === index? event.target.value : point
                      )
                  }: detail
                )}
              })
            )}
          />
        ))}
      </div>
    </div>
  )
}

export default ProjectBody
